// $( document ).ready(function() {
//   $('.addCard_btn').on('click', function(event) {
//   console.log("Meghas");
//   event.preventDefault();

//   var $quickAddButton = $(this).parents(".product-card__content").find('quick-add-component .quick-add__button--choose');
//   console.log($quickAddButton);
//   if ($quickAddButton.length) { 
//     $quickAddButton.trigger('click');
//   }
// });
// });



// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll(".addCard_btn").forEach(btn => {
//     btn.addEventListener("click", function (event) {
//       console.log("Meghas");
//       event.preventDefault();

//       // Find the closest .product-card__content parent
//       let productCard = this.closest(".product-card__content");
//       if (!productCard) return;

//       let quickAddComponent = productCard.querySelector("quick-add-component");
//       if (!quickAddComponent) return;

//       // Check if choose button exists
//       let chooseBtn = quickAddComponent.querySelector(".quick-add__button--choose");
//       let addBtn = quickAddComponent.querySelector(".quick-add__button--add");

//       if (chooseBtn) {
//         console.log("Product has variants → Open choose flow");
//         chooseBtn.click();
//       } else if (addBtn) {
//         console.log("Single variant product → Add directly");
//         addBtn.click();
//       }
//     });
//   });
// });

document.addEventListener("click", function (event) {
  // Check if the clicked element or its parent has .addCard_btn
  let btn = event.target.closest(".addCard_btn");
  if (!btn) return;

  console.log("Meghas");
  event.preventDefault();

  // Find the closest .product-card__content parent
  let productCard = btn.closest(".product-card__content");
  if (!productCard) return;

  let quickAddComponent = productCard.querySelector("quick-add-component");
  if (!quickAddComponent) return;

  // Check if choose button exists
  let chooseBtn = quickAddComponent.querySelector(".quick-add__button--choose");
  let addBtn = quickAddComponent.querySelector(".quick-add__button--add");

  if (chooseBtn) {
    console.log("Product has variants → Open choose flow");
    chooseBtn.click();
  } else if (addBtn) {
    console.log("Single variant product → Add directly");
    addBtn.click();
  }
});




